import React from 'react'

const EditBank = () => {
  return (
    <div>EditBank</div>
  )
}

export default EditBank